import {Settlement as ComponentSettlement} from './Settlement'
import {SettlementUser as ComponentSettlementUser} from './SettlementUser'

export const Settlement = ComponentSettlement;
export const SettlementUser = ComponentSettlementUser;